import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const turnTrackerRoutes = {
  name: 'turn-tracker',
  path: 'turn-tracker',
  component: () => import('./TurnTracker.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
